<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <date-picker label="Fecha Desde" ref="from"></date-picker>
        <date-picker label="Fecha Hasta" ref="to"></date-picker>
        <v-btn
          block
          outline
          color="primary"
          small
          @click="applyFilters"
          :loading="loading"
          >Aplicar Filtro</v-btn
        >
      </v-flex>
      <v-flex xs12 sm8>
        <v-layout row wrap v-if="initializing">
          <v-flex xs12 class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-else>
          <v-flex xs12 v-if="quotations.length === 0">
            <h3 class="font-weight-light text-xs-center mt-4">
              <span v-if="type === 'service'"
                >No hay presupuestos registrados</span
              >
              <span v-if="type === 'special_sale'"
                >No hay promociones registradas</span
              >
            </h3>
          </v-flex>
          <template v-else>
            <v-flex xs12 sm6 v-for="item in quotations" :key="item.id">
              <user-offer-single
                :item="item.special_sale"
                v-if="type === 'special_sale'"
                :quoted="item.quoted"
                :quotation="item.quotation"
              ></user-offer-single>
              <user-service-single
                :items="item.service_items"
                v-if="type === 'service'"
                :quoted="item.quoted"
                :quotation="item.quotation"
                :institution="item.service_provider.institution"
                :created="item.created_at"
              >
              </user-service-single>
            </v-flex>
            <v-flex xs12>
              <item-counter
                :length="quotations.length"
                :total="totalItems"
              ></item-counter>
              <next-page-btn
                :loading="loading"
                v-if="nextPageUrl"
                :nextFn="loadNextPage"
              ></next-page-btn>
            </v-flex>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { queryFilterBuilder } from '@/utils/Shared'

export default {
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    DatePicker: () => import('@/components/common/DatePicker'),
    NextPageBtn: () => import('@/components/common/NextPageBtn'),
    ItemCounter: () => import('@/components/common/ItemCounter'),
    UserOfferSingle: () => import('@/components/panel-data/UserOfferSingle'),
    UserServiceSingle: () => import('@/components/panel-data/UserServiceSingle')
  },
  data() {
    return {
      quotations: [],
      nextPageUrl: null,
      totalItems: 0,
      initializing: false
    }
  },
  mounted() {
    this.initialize()
  },
  computed: {
    loading() {
      return this.$store.getters['userQuotations/loading']
    }
  },
  methods: {
    async initialize() {
      this.initializing = true
      const payload = {
        type: this.type,
        query: null,
        doQuery: false
      }
      const data = await this.$store.dispatch('userQuotations/setType', payload)
      this.loadPageData(data)
      this.initializing = false
    },
    async apiConsulting(payload) {
      const data = await this.$store.dispatch('userQuotations/getData', payload)
      this.loadPageData(data)
    },
    loadPageData(data) {

      this.quotations = data.quotations.map(item => {
        item.quoted = !!item.quotation
        return item
      })
      this.nextPageUrl = data.nextPageUrl
      this.totalItems = data.total
    },
    async applyFilters() {
      const filters = {
        start_date: this.$refs.from.date,
        end_date: this.$refs.to.date
      }
      const query = queryFilterBuilder(filters)
      const payload = {
        isNextPage: false,
        query: query.query,
        doQuery: query.ok
      }
      await this.apiConsulting(payload)
    },
    async loadNextPage() {
      const payload = {
        isNextPage: true,
        query: null,
        doQuery: false
      }
      await this.apiConsulting(payload)
    }
  }
}
</script>
